import React, { useContext, useState } from 'react';
import './CSS/ShopCategory.css';
import { ShopContext } from '../Context/ShopContext';
import dropdown_icon from '../Components/Assets/dropdown_icon.png';
import Item from '../Components/Item/Item';

const ShopCategory = (props) => {
  const { all_product } = useContext(ShopContext);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [sortOption, setSortOption] = useState("Featured");
  const [visibleCount, setVisibleCount] = useState(8); // عدد المنتجات المعروضة مبدئيًا

  // ترتيب المنتجات حسب الفئة والاختيار
  const sortProducts = (products) => {
    let filtered = products.filter(
      (item) => props.category.toLowerCase() === item.category.toLowerCase()
    );

    switch (sortOption) {
      case "Price (low)":
        return filtered.sort((a, b) => a.new_price - b.new_price);
      case "Price (high)":
        return filtered.sort((a, b) => b.new_price - a.new_price);
      case "Alphabetical":
        return filtered.sort((a, b) => a.name.localeCompare(b.name));
      case "Newest":
        return filtered.sort((a, b) => new Date(b.date) - new Date(a.date));
      default:
        return filtered;
    }
  };

  const handleSortChange = (option) => {
    setSortOption(option);
    setDropdownOpen(false);
  };

  const sortedProducts = sortProducts(all_product);
  const visibleProducts = sortedProducts.slice(0, visibleCount);

  return (
    <div className='shop-category'>
      <img className='shopcategory-banner' src={props.banner} alt="" />

      <div className="shopcategory-indexSort">
        <div className="shopcategory-sort-wrapper">
          <div className="shopcategory-sort-btn" onClick={() => setDropdownOpen(!dropdownOpen)}>
            Sort by: {sortOption} <img src={dropdown_icon} alt="sort" />
          </div>

          {dropdownOpen && (
            <ul className="sort-dropdown">
              {["Featured", "Newest", "Price (low)", "Price (high)", "Alphabetical"].map((option, i) => (
                <li key={i} onClick={() => handleSortChange(option)}>{option}</li>
              ))}
            </ul>
          )}
        </div>
      </div>

      <div className="shopcategory-products">
        {visibleProducts.map((item, i) => (
          <Item
            key={i}
            id={item.id}
            name={item.name}
            image={item.image_urls?.[0] || item.image || 'https://via.placeholder.com/300'}
            new_price={item.new_price}
            old_price={item.old_price}
          />
        ))}
      </div>

      {/* زر Explore More يظهر فقط إن كان هناك المزيد */}
      {visibleCount < sortedProducts.length && (
        <div
          className="shopcategory-loadmore"
          onClick={() => setVisibleCount(prev => prev + 8)}
        >
          Explore More
        </div>
      )}
    </div>
  );
};

export default ShopCategory;


